import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FaqResponse } from 'src/admin-entity/interface/faq/faq.interface';
import * as api from 'src/api/chat-faq/chat-faq';
import { initialState } from './state';

export const fetchFaqList = createAsyncThunk<FaqResponse[], number>('faq/fetchFaqs', async lsBroadcastId => {
    const res = await api.fetchFaqList(lsBroadcastId);

    return res.data;
});

export const addFaq = createAsyncThunk<
    FaqResponse[],
    {
        lsBroadcastId: number;
        question: string;
        answer: string;
        formDate?: {
            faqAppUserId: number;
            faqAppUserSendDate: string;
        };
    }
>('faq/addFaq', async ({ lsBroadcastId, question, answer, formDate }) => {
    await api.createFaq(
        lsBroadcastId,
        question,
        answer,
        formDate?.faqAppUserId ?? null,
        formDate?.faqAppUserSendDate ?? null,
    );
    const res = await api.fetchFaqList(lsBroadcastId);
    return res.data;
});

export const editFaq = createAsyncThunk<
    FaqResponse[],
    { lsBroadcastId: number; faqId: number; question: string; answer: string }
>('faq/editFaq', async ({ lsBroadcastId, faqId, question, answer }) => {
    await api.updateFaq(lsBroadcastId, faqId, question, answer);
    const res = await api.fetchFaqList(lsBroadcastId);
    return res.data;
});

export const removeFaq = createAsyncThunk<FaqResponse[], { lsBroadcastId: number; faqId: number }>(
    'faq/removeFaq',
    async ({ lsBroadcastId, faqId }) => {
        await api.deleteFaq(lsBroadcastId, faqId);
        const res = await api.fetchFaqList(lsBroadcastId);
        return res.data;
    },
);

const faqSlice = createSlice({
    name: 'faq',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchFaqList.fulfilled, (state, { payload }) => {
            state.items = payload;
        });
        builder.addCase(addFaq.fulfilled, (state, { payload }) => {
            state.items = payload;
        });
        builder.addCase(editFaq.fulfilled, (state, { payload }) => {
            state.items = payload;
        });
        builder.addCase(removeFaq.fulfilled, (state, { payload }) => {
            state.items = payload;
        });
    },
});

export default faqSlice.reducer;
